import React, { createContext, useContext, useState } from 'react';

type EmailStatusType = 'idle' | 'loading' | 'success';

type EmailStatusContextType = {
  emailStatus: { [id: string]: EmailStatusType };
  setEmailStatus: React.Dispatch<React.SetStateAction<{ [id: string]: EmailStatusType }>>;
};

const EmailStatusContext = createContext<EmailStatusContextType | undefined>(undefined);

export const EmailStatusProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [emailStatus, setEmailStatus] = useState<{ [id: string]: EmailStatusType }>({});

  return (
    <EmailStatusContext.Provider value={{ emailStatus, setEmailStatus }}>
      {children}
    </EmailStatusContext.Provider>
  );
};

export const useEmailStatus = () => {
  const context = useContext(EmailStatusContext);
  if (!context) {
    throw new Error('useEmailStatus must be used within EmailStatusProvider');
  }
  return context;
};
